export interface IntegrityMonitorPolicyRuleSetsSectionWebComponentSchema {
  selectedRuleSets: Array<RuleSetItem>;
  companyRuleSets: Array<RuleSetItem>;
  isDisabled: () => boolean;
}

export interface RuleSetItem {
  _id: string;
  name: string;
  rulesCount: number;
}

export enum Column {
  RULE_SET_NAME = 1,
  RULES_COUNT,
  ACTIONS,
}

export const GRID_COLUMNS = [Column.RULE_SET_NAME, Column.RULES_COUNT, Column.ACTIONS];

export enum ColumnKeys {
  RULE_SET_NAME = 'name',
  RULES_COUNT = 'rulesCount',
  ACTIONS = 'actions',
}

export enum PolicyRuleSetsSectionEvents {
  RULE_SETS_SELECTION_CHANGE = 'ruleSetsSelectionChange',
  REMOVE_RULE_SET = 'removeRuleSet',
}
